/*
 * useFleetRouteAutoSelect
 *
 * With the fleet overview on, marking a vessel hides its fleet copy from the
 * map. This hook selects that vessel's fleet route in the tree instead, as
 * soon as both the mark and the fleet-plans list are known (either may land
 * first, e.g. a map-icon click opens the panel and the list loads after the
 * drill). Each vessel/route pair is auto-selected once per mark so a user's
 * deselection is not undone by a list refetch. Skipped while the eye is off.
 */

import { useEffect, useRef } from "react";
import { treeSelectionActions } from "@/features/routeTree/state/VesselTreeState.jsx";

export default function useFleetRouteAutoSelect({
  switchFleetPlan,
  switchVesselFiltersActive,
  markedVesselId,
  routeByVesselId,
  treeDispatch,
}) {
  const doneKeyRef = useRef(null);

  useEffect(() => {
    const vesselId = markedVesselId == null ? NaN : Number(markedVesselId);
    if (!Number.isFinite(vesselId)) {
      doneKeyRef.current = null;
      return;
    }
    if (!switchFleetPlan || !switchVesselFiltersActive) return;
    const fleetRoute = routeByVesselId?.[vesselId];
    const routeId = Number(fleetRoute?.id);
    if (!Number.isFinite(routeId)) return;
    const key = `${vesselId}:${routeId}`;
    if (doneKeyRef.current === key) return;
    doneKeyRef.current = key;
    treeDispatch(
      treeSelectionActions.ensureRouteSelected(
        vesselId,
        Number(fleetRoute.voyageId),
        routeId,
      ),
    );
  }, [
    switchFleetPlan,
    switchVesselFiltersActive,
    markedVesselId,
    routeByVesselId,
    treeDispatch,
  ]);
}
